var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07317 57.0825C1.58049 57.0825 1.06911 56.1131 1 55.6285V1H69V55.8362C69 56.667 68.0325 57.0132 67.5488 57.0825H3.07317Z",
    fill: "white",
    stroke: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7 14.0909C37.7 15.5205 36.5373 16.6819 35.1 16.6819C33.6627 16.6819 32.5 15.5205 32.5 14.0909C32.5 12.6614 33.6627 11.5 35.1 11.5C36.5373 11.5 37.7 12.6614 37.7 14.0909Z",
    fill: "white",
    stroke: "#3B3B3B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 51,
    r: 1.5,
    fill: "white",
    stroke: "#3B3B3B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1992,
    cy: 51,
    r: 1.5,
    fill: "white",
    stroke: "#3B3B3B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.3984,
    cy: 51,
    r: 1.5,
    fill: "white",
    stroke: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGateway);
export default __webpack_public_path__ + "static/media/home-gateway.8efda70601783cfbfd39a20e861938bc.svg";
export { ForwardRef as ReactComponent };